<div *ngIf="currentLang === 'ja'">
  <div class="manual-link">
    <a [href]="manualTopLink">使い方トップ</a> » プロジェクト情報：編集の説明
  </div>
  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card appearance="outlined" class="manual-card">
      <mat-card-header>
        <mat-card-title><span>プロジェクト情報：編集の説明</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/project-dialog-ja.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> 更新ボタン
        </div>
        <div class="manual-explain">
          クリックすることで編集内容が更新されます。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> 閉じるボタン
        </div>
        <div class="manual-explain">
          クリックすることでダイアログを閉じます。<br>
          その際、選択した内容は保存されません。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> ID
        </div>
        <div class="manual-explain">
          該当プロジェクトのIDが表示されます。<br>
          編集はできません。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> 名称
        </div>
        <div class="manual-explain">
          該当プロジェクトの名称が表示されます。<br>
          編集はできません。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/E.png"> アプリ表示名
        </div>
        <div class="manual-explain">
          該当プロジェクトのアプリ名を設定します。<br>
          編集ボタンから<a [href]="appnameDialogLink">アプリ表示名ダイアログ</a>を開き設定します。<br>
          <br>
          ここで設定された内容と施設名から、Webページのタイトルが生成されます。<br>
          ※「アプリ表示名 - 施設名」といった形式でタイトルになります。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/F.png"> マップ情報
        </div>
        <div class="manual-explain">
          マップ情報を設定します。<br>
          施設情報や建物・カテゴリ情報、フロア・表示グループ情報、展示物情報などで新規追加する時のデフォルトの所在位置となります。<br>
          マップ内の検索キーワード、または緯度軽度から指定可能です。<br>
        </div>

      </mat-card-content>
    </mat-card>

  </div>
</div>
<div *ngIf="currentLang === 'en'">
  <div class="manual-link">
    <a [href]="manualTopLink">User Guide Top</a> » Explanation of Project Information: Editing
  </div>
  
  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">
  
    <mat-card class="manual-card">
      <mat-card-header>
        <mat-card-title><span>Project Information: Explanation of Editing</span></mat-card-title>
      </mat-card-header>
  
      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/project-dialog-en.png" width="100%">
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> Update Button
        </div>
        <div class="manual-explain">
          Clicking this button will update the edited content.
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> Close Button
        </div>
        <div class="manual-explain">
          Clicking this button will close the dialog.<br>
          The selected content will not be saved.
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> ID
        </div>
        <div class="manual-explain">
          Displays the ID of the corresponding project.<br>
          Editing is not allowed.
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> Project Name
        </div>
        <div class="manual-explain">
          Displays the name of the corresponding project.<br>
          Editing is not allowed.
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/E.png"> App Display Name
        </div>
        <div class="manual-explain">
          Sets the app name for the corresponding project.<br>
          Open the <a [href]="appnameDialogLink">App Display Name Dialog</a> from the edit button to configure it.<br>
          <br>
          The content set here and the facility name will generate the title of the web page.<br>
          * The format will be "App Display Name - Facility Name".
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/F.png"> Map Information
        </div>
        <div class="manual-explain">
          Set map information.<br>
          This will be the default location when adding new facility information, building/category information, floor/display group information, exhibit information, etc.<br>
          Specify using search keywords or latitude and longitude within the map.<br>
        </div>
  
      </mat-card-content>
    </mat-card>
  
  </div>  
</div>